import * as styles from './ListItem.module.css'

function ListItem({ item }) {
  return (
    <tr className={styles.wrapper}>
      <td className={styles.item}>{item.name}</td>
      <td className={styles.item}>{item.value}</td>
    </tr>
  )
}

export default ListItem
